<template>
    <div class="container">
        <div class="field p-l-20">
            <Checkbox type="radio" name="duration_type" v-model="model.duration_type" data-value="temporal" label="Menos de un mes"></Checkbox>
        </div>
        <div class="field p-l-20">
            <Checkbox type="radio" name="duration_type" v-model="model.duration_type" data-value="indefinido" label="Más de un mes"></Checkbox>
        </div>
    </div>
</template>

<script>
import stepMixin from '../mixins/step';
import Checkbox from './Checkbox';

export default {
  name: 'funnel-paso-2',
  components: {
    Checkbox
  },
  mixins: [
    stepMixin
  ]
}
</script>
